import Request from "../handleRequest/Request";
export default {
  add(data) {
    return Request.post('qs/contact-us', data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
};
